import React, { Component } from 'react';
import { string, func, bool, node } from 'prop-types';
import TimePicker from 'react-time-picker';
import DatePicker from 'react-datepicker';
import isEdgeIE from 'helpers/detectEdgeIE';
import * as DateHelper from 'helpers/date';
import i18n from 'i18next';
import 'react-datepicker/dist/react-datepicker.css';
import './Input.css';

class Input extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.isEdgeIEDateTime = this.isEdgeIEDateTime.bind(this);
  }

  onFocus() {
    if (this.isEdgeIEDateTime()) {
      const pickers = document.getElementsByClassName('react-datepicker-popper');

      if (!pickers || pickers.length === 0) {
        requestAnimationFrame(() => {
          this.onFocus();
        });
      }

      for (let i = 0; i !== pickers.length; i += 1) {
        pickers.item(i).style.zIndex = 999999999999;
      }
    }
  }

  onChange(value, name) {
    const e = {
      target: {
        value,
        name,
      },
    };

    this.props.onChange(e);
  }

  isEdgeIEDateTime() {
    if ((isEdgeIE() || window.safari !== undefined) &&
       (this.props.type === 'date' || this.props.type === 'time')) {
      return true;
    }
    return false;
  }

  defaultRender() {
  // onKeyPress runs before onChange to check is valid or not.
    const onKeyPress = this.props.isOnlyNumbers
      ? {
        onKeyPress: (e) => {
          const keyCode = (e.which) ? e.which : e.keyCode;
          if (keyCode > 31 && (keyCode < 48 || keyCode > 57)
            && !(this.props.isAcceptingNegativeValue && keyCode === 45
                && e.target.selectionStart === 0)
            && !(this.props.isAcceptingFloat && keyCode === 46 && !String(e.target.value || '').includes('.'))) {
            e.preventDefault();
          }
        },
      } : {};

    const maxCharactersDate = this.props.type === 'date' ? {
      max: this.props.max || '9999-12-31',
    } : {};

    const {
      isOnlyNumbers,
      hasError,
      inputRef,
      ...props
    } = this.props;

    return (
      <input
        className={`input ${this.props.hasError ? 'input--error' : ''}`}
        {...props}
        ref={inputRef}
        {...onKeyPress}
        {...maxCharactersDate}
      />
    );
  }

  dateTimePicker(type) {
    if (type === 'time') {
      return (<TimePicker
        disableClock
        {...this.props}
        onChange={value => this.onChange(value, this.props.name)}

        value={this.props.value === 'Invalid date' ? '' : this.props.value}
      />);
    }

    return (
      <DatePicker
        {...this.props}
        minDate={this.props.min}
        maxDate={this.props.max}
        onChange={value => this.onChange(DateHelper.format(value, 'YYYY-MM-DD'), this.props.name)}
        onFocus={this.onFocus}
        value={this.props.value === 'Invalid date' ? '' : this.props.value}
        isClearable
        placeholderText={i18n.t('common:pleaseEnterDate')}
        withPortal
      />
    );
  }

  render() {
    if (this.isEdgeIEDateTime()) {
      return this.dateTimePicker(this.props.type);
    }
    return this.defaultRender();
  }
}

Input.propTypes = {
  onKeyPress: func,
  onChange: func,
  onBlur: func,
  placeholder: string,
  type: string,
  hasError: bool,
  value: string,
  min: string,
  max: string,
  name: string,
  isOnlyNumbers: bool,
  inputRef: node,
  isAcceptingNegativeValue: bool,
  isAcceptingFloat: bool,
};

Input.defaultProps = {
  onKeyPress: () => null,
  onBlur: () => null,
  placeholder: '',
  type: 'text',
  hasError: false,
  isOnlyNumbers: false,
  isAcceptingNegativeValue: false,
  isAcceptingFloat: false,
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Input.jsx